module.exports = __webpack_public_path__ + "img/project-banner.6bbb35df.jpg";